<template>
  <form>
    <CModal
        :title.sync="title"
        :color.sync="mode"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > {{ message }} </label>
          </CCol> 
          </CRow>
          <template #footer>
        <!-- <CButton @click="show = false" color="info">Ok</CButton> -->
        <CButton ref="btn" @click="close" color="info">Ok</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>

import EventBus from '@/eventBus';

export default {
name: 'alert',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      message: '',
    }
  },
  mounted(){
    var self = this;
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) { 
        self.close();
      }
    });    
  },
  created () {
    var self = this;

    EventBus.$on('OPEN_MODAL_ALERT', function (params) {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.message = params.data;
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
      // window.location.reload()
      EventBus.$emit('PAGE_RELOAD', true)
    },
  }
}
</script>

<style>

</style>